import NODE_TYPES from 'src/models/Ivrs/NodeTypes';

export const getNodeName = node => {
  if ([NODE_TYPES.IVR_NODE_DIAL, NODE_TYPES.IVR_NODE_VOICEMAIL].includes(node.type)) {
    return node.ivrNode.selection || node.ivrNode.description;
  }
  return node.ivrNode.name || node.ivrNode.description;
};
